export default "__VITE_ASSET__C4C8Y$HB__"